import React from 'react';
import { Modal } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import "../../assets/css/TeachingModal.css";

function TutorHiring({ isOpen, onClose }) {
  const history = useHistory();

  const handleClose = () => {
    localStorage.setItem('tutorHiringPopupSeen', 'true');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} size="lg" id="anouncementPopup" className="teaching-modal" centered>
      <div className="modal-content">
        <div className="modal-body p-0">
          <div className="teaching-container">
            <a onClick={handleClose} className="teaching-close" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </a>

            <div className="teaching-subtitle-gold">JOIN OUR TEACHING TEAM</div>
            <h2 className="teaching-title">We're Looking for PTE Academic & Core Tutors</h2>
            
            <p className="teaching-description">
              Join our passionate team and help students across both PTE pathways 
              achieve their dream scores — and their dream futures.
            </p>

            <div className="why-join-us">WHY JOIN US</div>

            <div className="perks-grid">
              <div className="perk-card">
                <span className="perk-icon">💰</span>
                <div className="perk-info">
                  <strong>Competitive Pay</strong>
                  <p>Above-market rates for the right candidate</p>
                </div>
              </div>
              <div className="perk-card">
                <span className="perk-icon">🕒</span>
                <div className="perk-info">
                  <strong>Flexible Hours</strong>
                  <p>Part-time & full-time options available</p>
                </div>
              </div>
              <div className="perk-card">
                <span className="perk-icon">📍</span>
                <div className="perk-info">
                  <strong>100% Online</strong>
                  <p>Teach students remotely from anywhere</p>
                </div>
              </div>
              <div className="perk-card">
                <span className="perk-icon">🚀</span>
                <div className="perk-info">
                  <strong>Grow With Us</strong>
                  <p>Ongoing PD & career opportunities</p>
                </div>
              </div>
            </div>

            <div className="looking-for-box">
              <p>
                <strong>Who we're looking for:</strong> Experienced tutors with proven expertise in both 
                <strong> PTE Academic</strong> and <strong>PTE Core</strong> — and a strong track record of improving 
                student scores across both tests. Excellent communication skills, a 
                student-first mindset, and the ability to start <strong>Immediately</strong> are essential.
              </p>
            </div>

            <a 
  href="/join-us" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="apply-now-btn"
  style={{ display: 'inline-block', textDecoration: 'none', textAlign: 'center' }}
>
  APPLY NOW &rarr;
</a>

            <p className="questions-text">
              Questions? Email us at <a href="mailto:info@languageacademy.com.au">info@languageacademy.com.au</a>
            </p>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default TutorHiring;
